export default "/images/home_prev_slide.svg?306a60ddf6e57666df7f2a0991cd9c28";